// import React from 'react'
// import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

// const MyPagination = ({ totalPages, currentPage, onPageChange }) => {
// 	const handlePageChange = (pageNumber) => {
// 		onPageChange(pageNumber);
// 	};
// 	return (
// 		<div className='d-flex justify-content-end'>
// 			<Pagination>
// 				<PaginationItem disabled={currentPage === 1}>
// 					<PaginationLink previous onClick={() => handlePageChange(currentPage - 1)}>Prev</PaginationLink>
// 				</PaginationItem>
// 				{Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNumber => (
// 					<PaginationItem key={pageNumber} active={pageNumber === currentPage}>
// 						<PaginationLink onClick={() => handlePageChange(pageNumber)}>
// 							{pageNumber}
// 						</PaginationLink>
// 					</PaginationItem>
// 				))}
// 				<PaginationItem disabled={currentPage === totalPages}>
// 					<PaginationLink next onClick={() => handlePageChange(currentPage + 1)}>Next</PaginationLink>
// 				</PaginationItem>
// 			</Pagination>
// 		</div>
// 	)
// }

// export default MyPagination

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const MyPagination = ({ totalPages, currentPage, onPageChange, className = '', size = 'sm' }) => {
	const { t } = useTranslation();
	const handlePageChange = (pageNumber) => {
		onPageChange(pageNumber);
	};

	const renderPageNumbers = () => {
		const pageNumbers = [];

		if (totalPages <= 5) {
			// Show all pages if there are 5 or fewer
			for (let i = 1; i <= totalPages; i++) {
				pageNumbers.push(i);
			}
		} else {
			// Show first 2, last 2, and current-related pages
			pageNumbers.push(1, 2);

			// Insert '...' if the current page is not close to the start
			if (currentPage > 4) {
				pageNumbers.push('...');
			}

			// Show current page with up to one page before and after
			const start = Math.max(3, currentPage - 1);
			const end = Math.min(totalPages - 2, currentPage + 1);

			for (let i = start; i <= end; i++) {
				pageNumbers.push(i);
			}

			// Insert '...' if the current page is not close to the end
			if (currentPage < totalPages - 3) {
				pageNumbers.push('...');
			}

			pageNumbers.push(totalPages - 1, totalPages);
		}

		return pageNumbers;
	};

	return (
		<div className={`d-flex justify-content-end align-items-center ${className}`}>
			<Pagination size={size} className="mb-0 pagination-sm" style={{ fontSize: '12px' }}>
				<PaginationItem disabled={currentPage === 1}>
					<PaginationLink previous onClick={() => handlePageChange(currentPage - 1)} style={{ padding: '4px 8px', fontSize: '12px' }}>
						{t("Prev")}
					</PaginationLink>
				</PaginationItem>
				{renderPageNumbers().map((pageNumber, index) => (
					<PaginationItem
						key={index}
						active={pageNumber === currentPage}
						disabled={pageNumber === '...'}
					>
						<PaginationLink
							onClick={() => pageNumber !== '...' && handlePageChange(pageNumber)}
							style={{ padding: '4px 8px', fontSize: '12px', minWidth: '28px', textAlign: 'center' }}
						>
							{pageNumber}
						</PaginationLink>
					</PaginationItem>
				))}
				<PaginationItem disabled={currentPage === totalPages}>
					<PaginationLink next onClick={() => handlePageChange(currentPage + 1)} style={{ padding: '4px 8px', fontSize: '12px' }}>
						{t("Next")}
					</PaginationLink>
				</PaginationItem>
			</Pagination>
		</div>
	);
};

export default MyPagination;
